import React from 'react';
import cn from 'classnames';
import './EyeCheckbox.css';

// interface EyeCheckboxProps {
//   id: string | number;
//   value: string | number;
//   checked: boolean;
//   onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
//   label?: React.ReactNode;
//   type?: 'checkbox' | 'radio';
//   name?: string;
//   disabled?: boolean;
//   inline?: boolean;
//   className?: string;
//   children?: React.ReactNode;
//   isLabelNeed?: boolean;
//   variant?: 'eye' | 'default';
// }

export const EyeCheckbox = ({
  id,
  type = 'checkbox',
  value,
  name,
  label = '',
  checked = false,
  disabled = false,
  onChange,
  className,
  inline = false,
  children,
  variant = 'eye',
}) => {
  if (variant === 'default') {
    const classes = cn('custom-control', `custom-${type}`, className, {
      'custom-control-inline': inline,
    });

    return (
      <div className={classes}>
        <input
          className="custom-control-input"
          type={type}
          id={String(id)}
          name={name}
          value={value}
          onChange={onChange}
          checked={checked}
          disabled={disabled}
          aria-checked={checked}
        />
        <label id={`label_for_${id}`} className="custom-control-label" htmlFor={String(id)}>
          {children ?? label}
        </label>
      </div>
    );
  }

  const classes = cn('eye-checkbox', className, {
    'eye-checkbox--inline': inline,
    'eye-checkbox--disabled': disabled,
    'eye-checkbox--radio': type === 'radio',
  });

  return (
    <div className={classes}>
      <input
        className="eye-checkbox__input"
        type={type}
        id={String(id)}
        name={name}
        value={value}
        onChange={onChange}
        checked={checked}
        disabled={disabled}
        aria-checked={checked}
      />
      <label className="eye-checkbox__label" htmlFor={String(id)}>
        <span className="eye-checkbox__text">{children ?? label}</span>
        <span className="eye-checkbox__icon">
          <svg
            className={cn('eye-icon', 'eye-open', { visible: checked })}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            aria-hidden="true"
          >
            <g clipPath="url(#clip0_634_9144)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.0159 5.00854C7.05662 5.00854 3.22818 8.51957 1.3703 10.5749C0.584131 11.4446 0.133488 12.089 0.133488 12.089C0.0454816 12.2151 -0.00170898 12.3651 -0.00170898 12.5189C-0.00170898 12.6726 0.0454816 12.8227 0.133488 12.9488C0.133488 12.9488 0.48807 13.4568 1.10914 14.1694C2.8531 16.1705 6.81152 20.0292 12.0159 20.0292C17.3581 20.0292 21.3928 15.9673 23.0621 14.0139C23.5982 13.3866 23.8999 12.9488 23.8999 12.9488C23.9879 12.8227 24.0351 12.6726 24.0351 12.5189C24.0351 12.3651 23.9879 12.2151 23.8999 12.089C23.8999 12.089 23.569 11.6123 22.9844 10.9358C21.2709 8.95326 17.2783 5.00854 12.0159 5.00854ZM12.0159 6.51091C16.5066 6.51091 20.2554 10.0754 21.8473 11.9174C22.166 12.2861 22.1961 12.3448 22.33 12.5218C22.2052 12.686 22.1906 12.7207 21.9192 13.0383C20.37 14.8511 16.5747 18.5269 12.0159 18.5269C7.5747 18.5269 3.86165 15.0424 2.24032 13.182C1.89216 12.7826 1.85468 12.7084 1.71361 12.5218C1.87697 12.3037 1.98041 12.1413 2.48386 11.5843C4.21457 9.66967 7.78386 6.51091 12.0159 6.51091ZM12.0159 8.01327C9.53564 8.01327 7.51326 10.0357 7.51326 12.516C7.51326 14.9963 9.53564 17.0245 12.0159 17.0245C14.4962 17.0245 16.5245 14.9963 16.5245 12.516C16.5245 10.0357 14.4962 8.01327 12.0159 8.01327ZM12.0159 9.5171C13.6846 9.5171 15.0221 10.8473 15.0221 12.516C15.0221 14.1846 13.6846 15.5221 12.0159 15.5221C10.3473 15.5221 9.01709 14.1846 9.01709 12.516C9.01709 10.8473 10.3473 9.5171 12.0159 9.5171Z"
                fill="currentColor"
              />
            </g>
            <defs>
              <clipPath id="clip0_634_9144">
                <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
              </clipPath>
            </defs>
          </svg>
          <svg
            className={cn('eye-icon', 'eye-closed', { visible: !checked })}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            aria-hidden="true"
          >
            <g>
              <path
                d="M21.3718 15.0515C21.2861 15.1004 21.1917 15.1319 21.0938 15.1442C20.996 15.1565 20.8967 15.1493 20.8016 15.1232C20.7065 15.0971 20.6175 15.0525 20.5397 14.9919C20.4618 14.9314 20.3967 14.856 20.348 14.7703L18.5668 11.6578C17.5312 12.358 16.3889 12.8855 15.1843 13.2197L15.7346 16.5215C15.7508 16.6187 15.7477 16.7182 15.7255 16.8142C15.7033 16.9102 15.6624 17.0009 15.6051 17.0811C15.5478 17.1613 15.4753 17.2294 15.3916 17.2815C15.308 17.3337 15.2149 17.3688 15.1177 17.385C15.0777 17.3915 15.0373 17.395 14.9968 17.3953C14.8194 17.395 14.6478 17.3319 14.5125 17.217C14.3772 17.1022 14.2871 16.9431 14.258 16.7681L13.7171 13.5262C12.5763 13.685 11.4191 13.685 10.2783 13.5262L9.7374 16.7681C9.7083 16.9434 9.61786 17.1028 9.48221 17.2176C9.34656 17.3325 9.17453 17.3955 8.99678 17.3953C8.95532 17.3951 8.91394 17.3917 8.87303 17.385C8.77581 17.3688 8.68273 17.3337 8.5991 17.2815C8.51547 17.2294 8.44294 17.1613 8.38565 17.0811C8.32836 17.0009 8.28743 16.9102 8.26521 16.8142C8.243 16.7182 8.23992 16.6187 8.25615 16.5215L8.80928 13.2197C7.60518 12.8844 6.46347 12.356 5.42865 11.655L3.65303 14.7703C3.55357 14.9436 3.38935 15.0703 3.19648 15.1225C3.00361 15.1747 2.79789 15.1482 2.62459 15.0487C2.45129 14.9493 2.32459 14.785 2.27238 14.5922C2.22016 14.3993 2.2467 14.1936 2.34615 14.0203L4.22115 10.739C3.56256 10.17 2.95695 9.54247 2.41178 8.86403C2.34379 8.78812 2.29198 8.69915 2.25952 8.60255C2.22706 8.50595 2.21463 8.40375 2.22298 8.30219C2.23133 8.20063 2.2603 8.10183 2.3081 8.01183C2.3559 7.92183 2.42155 7.84252 2.50102 7.77874C2.5805 7.71495 2.67214 7.66803 2.77035 7.64084C2.86856 7.61365 2.97129 7.60676 3.07225 7.62059C3.17321 7.63442 3.2703 7.66869 3.35758 7.72129C3.44486 7.77389 3.52051 7.84372 3.5799 7.92653C5.13615 9.85216 7.85865 12.1453 11.9968 12.1453C16.1349 12.1453 18.8574 9.84934 20.4137 7.92653C20.4724 7.84203 20.5478 7.77051 20.6354 7.71643C20.7229 7.66235 20.8207 7.62686 20.9225 7.61217C21.0244 7.59748 21.1281 7.60391 21.2274 7.63105C21.3267 7.6582 21.4193 7.70547 21.4995 7.76994C21.5797 7.83441 21.6457 7.9147 21.6936 8.0058C21.7414 8.0969 21.77 8.19687 21.7775 8.2995C21.7851 8.40212 21.7714 8.5052 21.7374 8.60232C21.7034 8.69944 21.6498 8.78852 21.5799 8.86403C21.0347 9.54247 20.4291 10.17 19.7705 10.739L21.6455 14.0203C21.6959 14.1058 21.7287 14.2005 21.7422 14.2988C21.7557 14.3971 21.7495 14.4972 21.724 14.5931C21.6986 14.689 21.6543 14.7789 21.5939 14.8576C21.5334 14.9363 21.4579 15.0022 21.3718 15.0515Z"
                fill="currentColor"
              />
            </g>
          </svg>
        </span>
      </label>
    </div>
  );
};
